import http from '@/utils/http'

export const getConnections = (nodeID, name, params = {}) => {
  let getUrl = `/kuiper/${nodeID}/metadata/connections`
  if (name) {
    getUrl = `${getUrl}/${name}`
  }
  return http.get(getUrl, { params })
}
export const getConnectionsYaml = (nodeID, name, params = {}) => {
  let getUrl = `/kuiper/${nodeID}/metadata/connections/yaml`
  if (name) {
    getUrl = `${getUrl}/${name}`
  }
  return http.get(getUrl, { params })
}

export const getConnectionsConfKeys = (nodeID, connections) => {
  return http.get(`/kuiper/${nodeID}/metadata/connections/${connections}/confKeys`)
}

export const addConnectionsConfKey = (nodeID, connections, name, body = {}) => {
  return http.put(`/kuiper/${nodeID}/metadata/connections/${connections}/confKeys/${name}`, body)
}

export const deleteConnectionsConfKey = (nodeID, connections, name) => {
  return http.delete(`/kuiper/${nodeID}/metadata/connections/${connections}/confKeys/${name}`)
}

export const loadConnectionsDetail = (nodeID, connections) => {
  return http.get(`/kuiper/${nodeID}/metadata/connections/yaml/${connections}`)
}

export default {}
